import React from 'react';
import { CheckBox } from './atom/checkbox';
import { Input } from './atom/input';
import { CustomTextArea } from './atom/textArea';
import { NativeSelect, CustomSelectInput } from './selectInput';
import type { DebouncedInputProps } from './types';

export * from './atom';
export * from './search-input';
export * from './types';

export { CheckBox, Input, NativeSelect, CustomSelectInput, CustomTextArea };

export const DebouncedInput = ({
  value: initialValue,
  onChange,
  debounce = 200,
  ...props
}: DebouncedInputProps) => {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value, onChange, debounce]);

  return (
    <Input
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
};
